import api from "../lib/axios";

export const userService = {
  getCurrentUser: async () => {
    const { data } = await api.get("/users/me");
    return data;
  },
  // get all users
  // getAllUsers: async (page, per_page) => {
  getAllUsers: async (params) => {
    try {
      const { data } = await api.get("/users", {
        params: {
          ...params
        }
      });
      return data;
    } catch (error) {
      throw new Error("Failed to fetch users: " + error.message);
    }
  },

  // create user
  createUser: async (userData) => {
    try {
      const { data } = await api.post("/users", userData);
      return data;
    } catch (error) {
      if (error.response?.data) {
        const apiError = error.response.data;
        const fieldErrors = apiError.errors || {};
        
        // If we have specific field errors, throw them
        if (Object.keys(fieldErrors).length > 0) {
          throw {
            message: apiError.message || 'Validation failed',
            errors: fieldErrors
          };
        }
        
        // Otherwise throw the general message
        throw new Error(apiError.message || "Failed to create user");
      }
      throw new Error("Failed to create user: " + error.message);
    }
  },
  // delete user
  deleteUser: async (userId) => {
    try {
      const { data } = await api.delete(`/users/${userId}`);
      return data;
    } catch (error) {
      throw new Error("Failed to delete user: " + error.message);
    }
  },
  // view user
  viewUser: async (userId) => {
    try {
      const { data } = await api.get(`/users/${userId}`);
      return data;
    } catch (error) {
      throw new Error("Failed to view user: " + error.message);
    }
  },
  updateUser: async (userId, userData) => {
    try {
      const { data } = await api.put(`/users/${userId}`, userData);
      return data;
    } catch (error) {
      if (error.response?.data) {
        const apiError = error.response.data;
        const fieldErrors = apiError.errors || {};
        
        // If we have specific field errors, throw them
        if (Object.keys(fieldErrors).length > 0) {
          throw {
            message: apiError.message || 'Validation failed',
            errors: fieldErrors
          };
        }
        
        // Otherwise throw the general message
        throw new Error(apiError.message || "Failed to update user");
      }
      throw new Error("Failed to update user: " + error.message);
    }
  },


  // getUser: async (userId) => {
  //   const { data } = await api.get(`/users/${userId}`);
  //   return data;
  // },

  // updateUser: async (userId, userData) => {
  //   const { data } = await api.put(`/users/${userId}`, userData);
  //   return data;
  // },
};

//get all users
// export const getAllUsers = async () => {
//   try {
//     const { data } = await api.get("/users");
//     return data;
//   } catch (error) {
//     throw new Error("Failed to fetch users: " + error.message);
//   }
// };
